/* global globalThis */

import useInterval from '@use-it/interval';
import useAxios from 'axios-hooks';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RouteChildrenProps } from 'react-router';
import { withRouter } from 'react-router-dom';
import { IState } from '../../models/states';

import Detail from './detail';
import Table from './table';
import { IDataRootObject, ISwitcherRootObject } from './types';

const SwitcherUI: React.FC<
  { token: string } & RouteChildrenProps<{ switcher_name?: string }>
> = ({ token, match }) => {
  const [rows, setRows] = useState<IDataRootObject[]>([]);
  const [lastFetched, setLastFetched] = useState<string>('');
  const [{ data }, refetch] = useAxios<ISwitcherRootObject>({
    url: `${globalThis.UI_CONFIG.backend_url}/v1/switcher`,
    headers: {
      Authorization: token
    }
  });

  // fetch interval
  useInterval(refetch, 30 * 1000);

  useEffect(() => {
    if (!data) {
      return;
    }

    setLastFetched(moment().format('H:mm:ss'));
    setRows(
      Object.values(data.result)
        .map((switcher) => ({
          switcher_id: switcher.ID,
          switcher_name: switcher.name,
          switch_mode: switcher.mode,
          type: switcher.type,
          status: switcher.status,
          updated_at: moment(switcher.updated_at).format('H:mm:ss'),
          active_source: switcher.sources.find(
            (player) => player.stream_id === switcher.active_stream_id
          ),
          backup_source: switcher.sources.find(
            (player) => player.stream_id !== switcher.active_stream_id
          ),
          preferred_source: switcher.sources.find(
            (player) => player.stream_id === switcher.preferred_stream_id
          )
        }))
        .flat()
        .map((c) => ({
          ...c,
          priority:
            c.status === 'AS_ERROR' ? 2 : c.status === 'AS_WARNING' ? 1 : 0,
          output:
            c.status === 'AS_ERROR'
              ? c.switch_mode === 'NA' ? 'Switcher not responding' : 'Loss of service'
              : c.status === 'AS_WARNING'
              ? 'Loss of redundancy'
              : 'Good'
        }))
        .sort((a, b) => b.priority - a.priority)
        .map((c, i) => ({
          ...c,
          slno: i + 1
        }))
    );
  }, [data, setRows, setLastFetched]);

  // return <><br /><br /><br /><br />{token}</>

  if (match.params.switcher_name) {
    return <Detail loading={!data} rows={rows} refetch={() => refetch()} />;
  }
  return <Table loading={!data} rows={rows} lastFetched={lastFetched} />;
};

interface IAppStateProps {
  token: string;
}

const mapStateToProps = (state: IState) => {
  return {
    token: state.user.token
  };
};

export default withRouter(
  connect<IAppStateProps>(mapStateToProps, {})(SwitcherUI)
);
